import { put, call, takeLatest, select } from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import { SESSIONCONTEXT_DATA, HEADERCONTEXT_DATA, SHOW_TOAST_WITH_PROPS } from "../../../common/actionConstants";
import { logout } from '../../WorkkardDetail/Saga/common';
import { LOG_APPLICATON_ERROR } from "../../../containers/WorkkardDetail/actions/actionConstants";
import jstz from 'jstimezonedetect';
import Cookies from 'js-cookie';
import { ErrorCode } from '../../../containers/WorkkardDetail/constants';
import { clearUsers } from '../../../common/slice/userList';
import { clearOrgs } from '../../../common/slice/orgList';

// export function* getUserSessionContextInfo() {
//     try {
//         const { status, sessionContext, OrganizationView, helperContext, tzData, navigation } = yield call(Api.getSessionContextInfo, ActionConstants.FETCH_USER_SESSIONCONTEXT_REQUEST, { _: new Date() });
//         if (status == 200) {
//             const isToastShow = Cookies.get('Show_Is_Toast_Displayed', { domain: $('#siteUrl').val() });
//             const timezoneName = jstz.determine().name();
//             const systemTimeZone = timezoneName == "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName;
//             console.log(`systemTimezone ${systemTimeZone} session timezone ${sessionContext.TimeZoneTz}`);
//             const nav = (navigation || []).reduce((r, e) => {
//                 r[e.OldName] = {
//                     "Name": e.Name, "Status": e.Status,
//                     "OldStatus": e.OldStatus, "Icon": e.Icon, "Route": e.Route
//                 };
//                 return r;
//             }, {});
//             sessionStorage.setItem('navigation', JSON.stringify(nav));
//             if (sessionContext.TimeZoneTz != systemTimeZone && isToastShow == "false") {
//                 const getToastData = (state) => state.toast;
//                 const toastData = yield select(getToastData);
//                 const toastPayload = {
//                     message: "You seem to be in a different time zone. Would you want to update the same for your ClaimColony?",
//                     type: "success",
//                     delayTime: 9000,
//                     showActions: true,
//                     isCloseIcon: false,
//                     autoClose: true,
//                     show: true,
//                     iconType: "report",
//                     entityType: "timezone",
//                     cId: toastData.cId,
//                     actId: toastData.actId
//                 }
//                 yield put({ type: SHOW_TOAST_WITH_PROPS, payload: toastPayload })
//             }
//             else if (sessionContext.TimeZoneTz == systemTimeZone && isToastShow == "false") {
//                 let domainName = $('#siteUrl').val();
//                 Cookies.set('Show_Is_Toast_Displayed', 'true', { domain: domainName });
//                 console.log("header/saga =  " + domainName);
//             }
//             yield put({
//                 type: SESSIONCONTEXT_DATA, payload: { ...sessionContext, OrganizationView, tzData, navigation: nav }
//             });
//             yield put({ type: HEADERCONTEXT_DATA, payload: { ...helperContext } });
//         }
//         else if (status == ErrorCode.RedirectToLogout) {
//             yield* logout();
//         } else {
//             yield put({
//                 type: LOG_APPLICATON_ERROR,
//                 payload: { status: status, isErrorScreen: false }
//             });
//         }
//     }
//     catch (error) { }
//     finally { }
// }


export function* updateUserTheme({ payload }) {
    try {
        const { status } = yield call(Api.updateUserTheme, ActionConstants.UPDATE_USER_THEME, payload);
        if (status == 200) {
            const getSessionContextData = (state) => state.sessionContext;
            const sessionContextData = yield select(getSessionContextData);
            yield put({ type: SESSIONCONTEXT_DATA, payload: { ...sessionContextData, UserSettingsView: { ...sessionContextData.UserSettingsView, UserTheme: payload.themeType } } });
        }
        else if (status == ErrorCode.RedirectToLogout) {
            yield* logout();
        } else {
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status: status, isErrorScreen: false }
            });
        }
    }
    catch (error) {
        console.log(error)
    }
    finally { }
}

export function* fetchUserOrgNameSuggestions({ payload }) {
    try {
        const { status, organization } = yield call(Api.fetchUserOrgNameSuggestions, ActionConstants.GET_USER_ORG_NAME_SUGGESTIONS, payload);
        if (status == 200 || organization.length > 0) {
            yield put({ type: ActionConstants.GET_USER_ORG_NAME_SUGGESTIONS_SUCCESS, payload: { orgSuggestion: organization } });
        }
        else if (status == ErrorCode.RedirectToLogout) {
            yield* logout();
        } else {
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status: status, isErrorScreen: false }
            });
        }
    }
    catch (error) { }
    finally { }
}

export function* fetchLeftNavigation({ payload }) {
    try {
        const { status, nav } = yield call(Api.fetchLeftNavigation, ActionConstants.GET_LEFT_NAVIGATION, payload);
        if (status == 200) {
            yield put({ type: ActionConstants.GET_LEFT_NAVIGATION_SUCCESS, payload: { leftNavigation: nav } });
        }
        else if (status == ErrorCode.RedirectToLogout) {
            yield* logout();
        } else {
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status: status, isErrorScreen: false }
            });
        }
    }
    catch (error) { }
    finally { }
}

export function* updateLayoutSetting({ payload }) {
    try {
        const { status } = yield call(Api.updateLayoutSetting, ActionConstants.UPDATE_LAYOUT_SETTINGS, payload);
        if (status == 200) {
            window.location.reload()
        }
        else if (status == ErrorCode.RedirectToLogout) {
            yield* logout();
        } else {
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status: status, isErrorScreen: false }
            });
        }
    }
    catch (error) {
        console.log(error)
    }
    finally { }
}

export function* switchOrgToken({ payload }) {
    try {
        const { status, isDiffrentUser, redirectUrl } = yield call(Api.switchOrgToken, ActionConstants.CHANGE_USER_ORG_TOKEN, payload);
        if (status == 200 && isDiffrentUser) {
            yield put(clearUsers());
            yield put(clearOrgs());
            window.location = redirectUrl
        }
        else if (status == ErrorCode.RedirectToLogout) {
            yield* logout();
        } else {
            yield put({
                type: LOG_APPLICATON_ERROR,
                payload: { status: status, isErrorScreen: false }
            });
        }
    }
    catch (error) {
        console.log(error)
    }
    finally { }
}



export default [
    // takeLatest(ActionConstants.FETCH_USER_SESSIONCONTEXT_REQUEST, getUserSessionContextInfo),
    takeLatest(ActionConstants.UPDATE_USER_THEME, updateUserTheme),
    takeLatest(ActionConstants.GET_USER_ORG_NAME_SUGGESTIONS, fetchUserOrgNameSuggestions),
    takeLatest(ActionConstants.GET_LEFT_NAVIGATION, fetchLeftNavigation),
    takeLatest(ActionConstants.UPDATE_LAYOUT_SETTINGS, updateLayoutSetting),
    takeLatest(ActionConstants.CHANGE_USER_ORG_TOKEN, switchOrgToken),
];